import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "@phosphor-icons/react";
import SEO from "../components/SEO";
import CallButton from "../components/CallButton";
import TrustBar from "../components/TrustBar";
import StaticMap from "../components/StaticMap";
import FinalCTABanner from "../components/FinalCTABanner";
import { CITIES } from "../data/cities";
import { IMAGES } from "../data/constants";

export default function Areas() {
  return (
    <>
      <SEO
        title="Service Areas | GTA Garage Doors & Locksmith"
        description="We serve every major Greater Toronto Area city 24/7 - Toronto, Vaughan, Mississauga, Brampton, Markham, Richmond Hill and more. Call for fast local service."
        canonical="/areas"
        ogImage={IMAGES.torontoSkyline}
      />

      <section className="relative bg-[#1B2A4A] text-white" data-testid="areas-hero">
        <img
          src={IMAGES.torontoSkyline}
          alt="Toronto skyline representing GTA-wide emergency service coverage"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A] via-[#1B2A4A]/85 to-[#1B2A4A]/40" aria-hidden />
        <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24 lg:py-28">
          <nav className="text-xs text-white/60 font-bold uppercase tracking-widest font-display">
            <Link to="/" className="hover:text-[#FF6B00]" data-testid="areas-breadcrumb-home">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-white">Service Areas</span>
          </nav>
          <h1 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl leading-[1.05]">
            From Oakville to Scarborough. <span className="text-[#FF6B00]">We're nearby.</span>
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-white/85 leading-relaxed">
            Dispatched across 12 cities in the Greater Toronto Area, 24 hours a
            day. Most calls on-site within an hour.
          </p>
          <div className="mt-8">
            <CallButton size="lg" testId="areas-hero-call-button" />
          </div>
        </div>
      </section>

      <TrustBar variant="dark" />

      <section className="section-pad bg-white">
        <div className="container-wide">
          <StaticMap city="GTA Coverage" testId="areas-map" />

          <div className="mt-12 eyebrow">All service areas</div>
          <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl tracking-tight text-[#1B2A4A]">
            Pick your city.
          </h2>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {CITIES.map((c) => (
              <Link
                key={c.slug}
                to={`/areas/${c.slug}`}
                data-testid={`area-card-${c.slug}`}
                className="group rounded-sm border border-[#E2E8F0] bg-white p-6 hover:-translate-y-1 hover:border-[#FF6B00] hover:shadow-md transition-all"
              >
                <div className="flex items-center gap-3">
                  <div className="inline-flex h-10 w-10 items-center justify-center rounded-sm bg-[#1B2A4A]">
                    <MapPin size={20} weight="fill" className="text-[#FF6B00]" />
                  </div>
                  <div className="font-display font-black text-xl text-[#1B2A4A] tracking-tight">{c.name}</div>
                </div>
                <p className="mt-3 text-sm text-[#4B5563] line-clamp-3 leading-relaxed">
                  {c.intro.split(". ").slice(0, 2).join(". ") + "."}
                </p>
                <div className="mt-4 inline-flex items-center gap-2 text-sm font-bold font-display text-[#FF6B00] uppercase tracking-wider">
                  View {c.name} services
                  <ArrowRight size={14} weight="bold" className="group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <FinalCTABanner />
    </>
  );
}
